export * from "./direccion";
export * from "./contacto";


// WEBPACK FOOTER //
// ./app/features/selectores/items/direccioncliente/index.tsx